module.exports = [{"title":"토노베이션","description":"","position":{"lat":35.21289818910496,"lng":129.08055087877594}}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/cities.json
// module id = Kcxh
// module chunks = 1